var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "modal-device-setting-component" }, [
    _c(
      "div",
      { staticClass: "modal-device-setting" },
      [
        !_vm.isMobile && _vm.isDevicetest
          ? _c("img", {
              staticClass: "device-set-preview-gooroomee-header",
              attrs: {
                src: require("@/assets/images/camstudy/preview_gooroomee_name.svg"),
              },
            })
          : _vm._e(),
        _c("CamstudyPreview", {
          ref: "devicePreview",
          attrs: {
            roomInfo: _vm.roomInfo,
            isShowCoachmark: _vm.isShowCoachmark,
            isDevicetest: _vm.isDevicetest,
          },
          on: {
            onToggleInfo: _vm.toggleInfo,
            reqJoin: _vm.reqJoin,
            reqApproveJoin: _vm.reqApproveJoin,
            onUpdatePreview: _vm.onUpdatePreview,
            onUpdateNickname: _vm.onUpdateNickname,
          },
        }),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }